import PadCreatePage from './padCreatePage';

export default PadCreatePage;
